
export const firstTrStyles = {
  background: 'white'
};

export const fontStyles = {
  fontSize: '14px'
};

export const firstTdStyles = {
  border: 'none'
};

export const tdStyles = (isLink) => {
  return {
    ...fontStyles,
    paddingTop: '.75rem',
    paddingBottom: '.75rem',
    color: isLink ? '#319bd5' : 'default',
    border: 'none'
    };
};

export const tdLinkStyles = {
    ...fontStyles,
    cursor:'pointer'
}

export const backgroundStyles = {
  background: "white",
  border:'1px solid rgba(0,0,0,.125)',
  borderRadius: '4px',
  marginBottom: '2rem'
};

export const theadStyles = {
  background: 'whitesmoke'
};

export const tableHeaderStyles = {
  ...fontStyles,
  fontWeight: '400',
  paddingTop: '.5rem',
  paddingBottom: '.5rem',
  border: 'none'
};

export const selectStyles = {
  height: '2.5em',
  ...fontStyles
};

export const iconStyles = {
  color: 'darkgrey',
  cursor: 'pointer',
  size: '.8em'
};
